export default __webpack_public_path__ + "3276c96.png";